/*
 * Copyright © 2018-2026, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

export enum PetGender {
  MALE = "MALE",
  FEMALE = "FEMALE",
  CASTRATED_MALE = "CASTRATED_MALE",
  CASTRATED_FEMALE = "CASTRATED_FEMALE",
}

export const convertFromPetVetDataGender = (gender: string, isCastrated: boolean): PetGender => {
  if(gender === "hím"){
    if(isCastrated){
      return PetGender.CASTRATED_MALE;
    } else {
      return PetGender.MALE;
    }
  } else {
    if(isCastrated){
      return PetGender.CASTRATED_FEMALE;
    } else {
      return PetGender.FEMALE;
    }
  }
}
